import { useEffect } from 'react';
import { Box, Text } from '@chakra-ui/react';

import Head from './components/head';
import Table from './components/table';
import { useFilters } from './hooks/state/useFilters';
import { useStateParahub } from './hooks/state/useStateParahub';
import { useCustomerDetail } from './hooks/state/useCustomerDetail';

const Parahub = () => {
    const filters = useFilters();
    const stateParahub = useStateParahub();
    const { resetState } = useCustomerDetail();

    useEffect(() => {
        filters.reset();
        stateParahub.reset();
        resetState();
    }, []);

    return (
        <Box p={'20px'} bg={'semantic.100'} borderRadius={'8px'} boxShadow={'0px 1px 3px 0px #0D0A2C1A'}>
            <Text fontWeight={700} fontSize="24px" mb={'24px'}>
                Parahub - Store Configuration
            </Text>

            <Head />
            <Table />
        </Box>
    );
};

export default Parahub;
